"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Requestors for analytics-related data
 */
var analytics = require("consumerweb-analytics"), u = require("commonweb-utils").objectUtils, APP_ROOT = require("../app/constants").APP_ROOT, BASE_URI = require("../app/constants").BASE_URI, MAX_PARENT_COUNT = 5;
/**
 * Generates Analytics pageName from URL
 * @param url
 * @returns string of pageName from URL
 */
function getPageName(url) {
    var nameFromUrl = url.replace(/.*\/myaccount\/(.*?)(\?.*)/, "$1");
    // Removes '/flow' from the url to keep page names consistent
    nameFromUrl = nameFromUrl.replace("/flow", "");
    // Creates consistent page name for /myaccount/profile or /myaccount/profile/
    if (nameFromUrl === APP_ROOT + "/") {
        nameFromUrl = nameFromUrl.replace("/", "");
    }
    if (!nameFromUrl) {
        nameFromUrl = APP_ROOT;
    }
    else {
        // Replace BA-alphanumeric or CC-alphanumeric (i.e remove cards & bank id's)
        // Ex: /money/cards/CC-UCY68ZQHC74NU => /money/cards
        nameFromUrl = nameFromUrl.replace(/\/([BA|CC]+)([-]{1})([a-zA-Z0-9]+)/, "");
        // Ex: /connect/I-123ASDFGHJKL => /connect/id
        var reg = new RegExp(BASE_URI + "/([I|B|S]-.*)");
        nameFromUrl = nameFromUrl.replace(reg, BASE_URI + "/id");
        //remove Ids from url
        nameFromUrl = nameFromUrl.replace(/\/([A-Z0-9]+)/, "");
        // Adds double colon if there are any trailing name left
        // Ex: cards/update => cards::update
        var regex = new RegExp(APP_ROOT + "/(.*?)/", "g");
        nameFromUrl = nameFromUrl.replace(regex, APP_ROOT + ":$1::");
    }
    return nameFromUrl.replace(/\//g, ":");
}
/**
 * This function is created to get device info whether DESKTOP or mWeb or WEBVIEW
 * returns any one value from the set : [DESKTOP, MOBILE, WEBVIEW]
 */
function getDeviceInfo(storeData) {
    var pageInfo = u.safeGet(storeData, "pageInfo");
    if (!pageInfo) {
        return "DESKTOP";
    }
    var userAgent = u.safeGet(pageInfo, "userAgent");
    var deviceType = u.safeGet(pageInfo, "deviceType") || "DESKTOP";
    if (userAgent && userAgent.indexOf("PayPalMobile") >= 0) {
        deviceType = "WEBVIEW";
    }
    return deviceType;
}
function getParentTrackingNode(elementNode, parentLevel) {
    if (parentLevel === void 0) { parentLevel = MAX_PARENT_COUNT; }
    if (parentLevel <= 0 || !elementNode) {
        return null;
    }
    var nodeTrackingLinkName = getNodeTrackingLinkName(elementNode);
    if (nodeTrackingLinkName) {
        return elementNode;
    }
    return getParentTrackingNode(elementNode.parentElement, --parentLevel);
}
function getNodeTrackingLinkName(node) {
    return (node.name ||
        node.getAttribute("data-name") ||
        node.getAttribute("for") ||
        null);
}
function initialize(req, res, callback) {
    req.model = req.model || {};
    req.model.analyticsPageName = getPageName(req.originalUrl);
    analytics.setupAnalytics(req, res, callback);
}
/**
 *  Exports Analytics Utils
 */
exports.default = {
    init: initialize,
    getPageNameFromUrl: getPageName,
    getDeviceInfo: getDeviceInfo,
    getParentTrackingNode: getParentTrackingNode,
    getNodeTrackingLinkName: getNodeTrackingLinkName,
};
